"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayClientDetailListRequestSerialiser = exports.GatewayClientDetailListRequestSerialiserClass = void 0;
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link GatewayConnectedClientDetails}
 */
var GatewayClientDetailListRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayClientDetailListRequestSerialiserClass, _super);
    function GatewayClientDetailListRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayClientDetailListRequest} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayClientDetailListRequest} that was read
     */
    GatewayClientDetailListRequestSerialiserClass.prototype.read = function (bis) {
        var types = Codec.readByte(bis) ? Codec.readCollection(bis, Codec.readString) : undefined;
        var ids = Codec.readByte(bis) ? Codec.readCollection(bis, Codec.readString) : undefined;
        return {
            types: types,
            ids: ids
        };
    };
    /**
     * Write a {@link GatewayClientDetailListRequest} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link GatewayClientDetailListRequest} to write
     */
    GatewayClientDetailListRequestSerialiserClass.prototype.write = function (bos, value) {
        if (value.types !== undefined && value.types !== null) {
            Codec.writeByte(bos, 1);
            Codec.writeCollection(bos, value.types, Codec.writeString);
        }
        else {
            Codec.writeByte(bos, 0);
        }
        if (value.ids !== undefined && value.ids !== null) {
            Codec.writeByte(bos, 1);
            Codec.writeCollection(bos, value.ids, Codec.writeString);
        }
        else {
            Codec.writeByte(bos, 0);
        }
    };
    return GatewayClientDetailListRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayClientDetailListRequestSerialiserClass = GatewayClientDetailListRequestSerialiserClass;
/**
 * The {@link GatewayClientDetailListRequestSerialiser} singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.GatewayClientDetailListRequestSerialiser = new GatewayClientDetailListRequestSerialiserClass();
